//  +----------------------------------------------------------------------
//  | 球友会 [ 关于台球，就用球友汇 ]
//  +----------------------------------------------------------------------
//  | Copyright (c) 2025 https://www.qyxtyfz.com All rights reserved.
//  +----------------------------------------------------------------------

import store from "../store";
import Cache from '../utils/cache';
import {
	Debounce,throttle
} from '@/utils/validate.js'
// #ifdef H5 || APP-PLUS
import {
	isWeixin
} from "../utils";
// #endif
// #ifdef H5
import auth from './wechat';

// #endif

import {
	getUserInfo
} from '@/api/user';
import {
	uploadDeviceCode
} from '@/api/api';

import {
	LOGIN_STATUS,
	USER_INFO,
	EXPIRES_TIME,
	STATE_R_KEY,
	BACK_URL,
	TOKEN_EXPIRES_SECONDS
} from './../config/cache';

function prePage() {
	let pages = getCurrentPages();
	let prePage = pages[pages.length - 1];
	return prePage.$page.fullPath;
}

export const toLogin = throttle(_toLogin, 800,true)

export function _toLogin(push, pathLogin) {
	// 公众号登录方式(单选),1微信授权，2手机号登录/
	let publicLoginType = getApp().globalData.publicLoginType;

	store.commit("LOGOUT");
	let path = prePage();
	let login_back_url = Cache.get(BACK_URL);
	// #ifdef H5
	path = location.href;
	path = location.pathname + location.search;
	// #endif
	if (!pathLogin) {
		pathLogin = '/page/users/login/index'
		Cache.set(BACK_URL, path);
	}

	// #ifdef H5
	if (isWeixin() && publicLoginType == 1) {
		let urlData = location.pathname + location.search
		if (urlData.indexOf('?') !== -1) {
			urlData += '&go_longin=1';
		} else {
			urlData += '?go_longin=1';
		}
		if (!Cache.has('snsapiKey')) {
			auth.oAuth('snsapi_base', urlData);
		} else {
			if (['/pages/user/index'].indexOf(login_back_url) == -1) {
				uni.navigateTo({
					url: '/pages/users/wechat_login/index'
				})
			}
		}
	} else {
		if (['/pages/user/index'].indexOf(login_back_url) == -1) {
			uni.navigateTo({
				url: '/pages/users/login/index'
			})
		}
	}
	// #endif

	if (['pages/user/index', '/pages/user/index'].indexOf(login_back_url) == -1) {
		// #ifdef MP
		uni.navigateTo({
			url: '/pages/users/wechat_login/index'
		})
		// #endif
		// #ifdef APP-PLUS
		// uni.showModal({
		//     title: '登录提示',
		//     content: '登录以后可体验商城完整功能',
		// 	cancelColor: '#000000',
		// 	confirmColor: '#526BB1',
		//     success: function (res) {
		//         if (res.confirm) {
		//            uni.navigateTo({
		//            	url: '/pages/users/login/index'
		//            })
		//         } else if (res.cancel) {
		//             // console.log('用户点击取消');
		//         }
		//     }
		// });
		uni.navigateTo({
			url: '/pages/users/login/index'
		})
		// #endif
	}
}


export function handleLoginSuccess(store, data) {
	store.commit("LOGIN", { token: data.token, expiresTime: data.expiresTime });
	store.commit("SETUID", data.uid);
	const cid = uni.getStorageSync("cid");
	if (cid) uploadDeviceCode(cid).catch(() => {});
	return getUserInfo().then(res => {
		store.commit("UPDATE_USERINFO", res.data);
		return res.data;
	});
}

export function checkLogin() {
	let token = Cache.get(LOGIN_STATUS);
	if (!token) {
		Cache.clear(LOGIN_STATUS);
		Cache.clear(EXPIRES_TIME);
		Cache.clear(USER_INFO);
		Cache.clear(STATE_R_KEY);
		store.commit("LOGOUT");
		return false;
	}
	let expiresTime = Cache.get(EXPIRES_TIME);
	let newTime = Math.round(new Date() / 1000);
	if (!expiresTime) {
		Cache.set(EXPIRES_TIME, newTime + TOKEN_EXPIRES_SECONDS);
	} else if (Number(expiresTime) < newTime) {
		Cache.clear(LOGIN_STATUS);
		Cache.clear(EXPIRES_TIME);
		Cache.clear(USER_INFO);
		Cache.clear(STATE_R_KEY);
		store.commit("LOGOUT");
		return false;
	}
	store.commit('UPDATE_LOGIN', token);
	let userInfo = Cache.get(USER_INFO, true);
	if (userInfo) {
		store.commit('UPDATE_USERINFO', userInfo);
	}
	return true;
}

export function refreshExpires() {
	if (Cache.get(LOGIN_STATUS)) {
		Cache.set(EXPIRES_TIME, Math.round(new Date() / 1000) + TOKEN_EXPIRES_SECONDS);
	}
}

// 清除登录态（本地缓存 + store），用于服务端判定 token 失效时切回访客
export function logout() {
	Cache.clear(LOGIN_STATUS);
	Cache.clear(EXPIRES_TIME);
	Cache.clear(USER_INFO);
	Cache.clear(STATE_R_KEY);
	store.commit("LOGOUT");
}

// 统一登录守卫：已登录返回 true；未登录写回跳地址并跳登录页，返回 false
export function requireLogin(backUrl) {
	if (checkLogin()) return true;
	if (backUrl) {
		Cache.set(BACK_URL, backUrl);
	}
	// #ifdef MP
	uni.navigateTo({ url: '/pages/users/wechat_login/index' });
	// #endif
	// #ifdef APP-PLUS
	uni.navigateTo({ url: '/pages/users/login/index' });
	// #endif
	// #ifdef H5
	toLogin();
	// #endif
	return false;
}